import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";
import CommunicationPreferencesPage from "./communicationPreferencesPage";
import UpdateCommunicationPreferences from "./updateCommunicationPreferences";

const CommunicationPreferences: FC = () => {
  return (
    <Routes>
      <Route path="/update" element={<UpdateCommunicationPreferences />} />
      <Route index element={<CommunicationPreferencesPage />} />
    </Routes>
  );
};

export default CommunicationPreferences;
